import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/performer/performer_list',
	ADD: '/performer/performer_add',
	UPDATE: '/performer/performer_update',
	UPDATE_DISABLE: '/performer/performer_update_disable',
	RESET_PASSWORD: '/performer/performer_reset_password',
	
	BIND_GOOGLE_AUTH: '/performer/performer_bind_google_auth',
	BIND_GOOGLE_AUTH_PRO: '/performer/performer_bind_google_auth_pro',
	UNBIND_GOOGLE_AUTH: '/performer/performer_unbind_google_auth',
}

export async function performerList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function performerAdd(queryParams) {
    return requestPost(api.ADD, queryParams);
}

export async function performerUpdate(queryParams) {
    return requestPost(api.UPDATE, queryParams);
}

export async function performerUpdateDisable(id, disabled) {
	let params = {
		id: id,
		disabled: disabled
	};
	
    return requestPost(api.UPDATE_DISABLE, params);
}

export async function performerResetPassword(form) {
	return requestPost(api.RESET_PASSWORD, form);
}


export async function performerBindGoogleAuth(id) {
	let params = {
		id: id
	};
	return requestGet(api.BIND_GOOGLE_AUTH, params);
}

export async function performerBindGoogleAuthPro(params) {
	return requestPost(api.BIND_GOOGLE_AUTH_PRO, params);
}

export async function performerUnBindGoogleAuth(id) {
	let params = {
		id: id
	};
	return requestPost(api.UNBIND_GOOGLE_AUTH, params);
}

